import { ICON_PRIMARY_GRADIENT_SELECTED } from "../../../theme";
import { BUTTON_PRIMARY_GRADIENT_HOVER } from "../../../theme";
import { BUTTON_PRIMARY_GRADIENT_SELECTED } from "../../../theme";
import styled from "@emotion/styled";

const NavItem = styled.span<{ isActive?: boolean; isExpanded?: boolean }>`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  padding: 10px;
  gap: 8px;
  border-radius: 100px;
  align-items: flex-start;
  min-width: 20px;
  flex-shrink: 0;
  text-wrap: nowrap;
  background: ${(props) =>
    props.isActive && props.isExpanded
      ? BUTTON_PRIMARY_GRADIENT_SELECTED
      : "none"};
  &:hover {
    background: ${BUTTON_PRIMARY_GRADIENT_HOVER};
  }
  height: 20px;
  ${(props) =>
    props.isActive &&
    !props.isExpanded &&
    `
    width: 20px;
    background: ${ICON_PRIMARY_GRADIENT_SELECTED};
      padding: 10px;
    `}
`;

export default NavItem;
